import * as React from 'react';
import styled from 'styled-components';

import { FolderId } from 'modules/domains/foldering';
import { FOLDER_ID_SEARCH_PARAM } from 'modules/templateIndex/constants';
import { link2, colors } from 'ui/theme';
import { fontSizes } from 'ui/theme/typography';
import { SearchParamLink } from 'ui/utility/SearchParamLink/SearchParamLink';
import { hasHorizontalOverflow } from 'utils/elementHelpers';
import { Label } from '../Folders.styles';
import { PAGE_SEARCH_PARAM } from 'modules/campaignIndex/constants';

export const StyledLargeLink = styled(SearchParamLink)`
  ${link2}
  color: ${colors.textPrimary};
  text-decoration-color: transparent;

  ${({ $isMini }: { $isMini?: boolean }) =>
    $isMini ? `font-size: ${fontSizes.s12}; line-height: ${fontSizes.s16};` : ''}
`;

type Props = {
  /** the folder id */
  id: FolderId;
  /** if this is the last breadcrumb */
  isLastCrumb?: boolean;
  /** if the breadcrumb is an active link */
  isLink: boolean;
  /** if this is the tinier display version */
  isMini?: boolean;
  /** the name of the breadcrumb */
  name: string;
  /** an updated function to alert if the name overflows the container */
  handleOverflow: (arg: boolean) => void;
};

/**
 * A breadcrumb triggers an optional tooltip
 */
export const BreadcrumbName = ({
  id,
  isLastCrumb = false,
  isLink,
  isMini = false,
  name,
  handleOverflow,
}: Props) => {
  const myRef = React.useRef<HTMLElement>(null);

  React.useEffect(() => {
    if (myRef.current) {
      const hasOverflow = hasHorizontalOverflow(myRef.current);
      if (hasOverflow) {
        handleOverflow(hasOverflow);
      }
    }
  }, []);

  return (
    <Label isLastItem={isLastCrumb} ref={myRef} isMini={isMini}>
      {isLink ? (
        <StyledLargeLink
          $isMini={isMini}
          searchParams={{
            [FOLDER_ID_SEARCH_PARAM]: id.toString(),
          }}
          deleteSearchParams={[PAGE_SEARCH_PARAM]}
        >
          {name}
        </StyledLargeLink>
      ) : (
        <span>{name}</span>
      )}
    </Label>
  );
};
